import { Observable } from 'rxjs';

import { ObserveModulesByIdsQuery } from 'module/query/observe-modules-by-ids.query';

import { Module } from '../../../domain/module/module';
import { ModuleType } from '../model/module.type';
import { ObserveModulesQuery } from '../query/observe-modules.query';

export abstract class ModuleRepositoryPort {
	public abstract observeModules(
		query: ObserveModulesQuery
	): Observable<Module[]>;

	public abstract saveModules(phases: Module[]): Promise<void>;

	public abstract observeModulesByIds(
		query: ObserveModulesByIdsQuery
	): Observable<Module[]>;

	public abstract observeModuleById(moduleId: string): Observable<Module>;

	public abstract observeModuleByType(type: ModuleType): Observable<Module>;
}
